export const ADD_NOTE = 'ADD_NOTE'
export const REMOVE_NOTE = 'REMOVE_NOTE'
export const EDIT_NOTE = 'EDIT_NOTE'
export const SET_NOTES = 'SET_NOTES'
export const CLEAN_NOTES = 'CLEAN_NOTES'


export const LOGIN = 'LOGIN'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_SUCCESS = 'RESET_SUCCESS'
export const RESET_FAILURE = 'RESET_FAILURE'
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS'
export const AUTH_START = 'AUTH_START'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAILURE = 'AUTH_FAILURE'

export const GET_USER_UID = 'GET_USER_UID'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_DATA_FAILURE = 'SET_USER_DATA_FAILURE'